export default "__VITE_ASSET__CM49XKQM__"